<template>
  <div class="page-graduate-result">
    <div class="header">
      <a class="logo"></a>
    </div>
    <div class="body">
      <div class="result-wrap">
        <div class="result-title">毕业证书查询结果</div>
        <div class="result-content">
          <div v-if="resultList.length === 0" class="no-data">
            暂无数据
          </div>
          <div v-else class="result-list">
            <div
              v-for="(item, index) in resultList"
              :key="index"
              class="result-card">
              <div class="card-header">
                <span class="card-title">证书</span>
              </div>
              <div class="card-body">
                <div class="info-section">
                  <div class="info-item">
                    <span class="label">学号</span>
                    <span class="value">{{ item.regNo || '' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">姓名</span>
                    <span class="value">{{ item.trueName || '' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">性别</span>
                    <span class="value">{{ item.gender || '' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">出生日期</span>
                    <span class="value">{{ item.birthDate || '' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">所属教学点</span>
                    <span class="value">{{ item.siteName || '' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">毕业证书编号</span>
                    <span class="value">{{ item.graduateCertNo || '' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="label">毕业时间</span>
                    <span class="value">{{ item.graduateDate || '' }}</span>
                  </div>
                </div>
                <div v-if="item.photoLink" class="photo-section">
                  <img :src="item.photoLink" alt="照片" class="student-photo">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="result-footer">
        <el-button
          type="primary"
          round
          @click="goBack">
          返回查询
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GraduateResultPage',
  data () {
    return {
      resultList: []
    }
  },
  created () {
    // 从路由params获取查询结果（刷新页面时params会丢失）
    if (this.$route.params.resultList) {
      this.resultList = this.$route.params.resultList
    }
    // 如果没有数据，跳回查询页面
    if (this.resultList.length === 0) {
      this.$router.replace('/graduate/query')
    }
  },
  methods: {
    goBack () {
      this.$router.replace('/graduate/query')
    }
  }
}
</script>

<style lang="scss">
.page-graduate-result {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding: 30px 15px;

  .header {
    .logo {
      display: block;
      height: 42px;
      background: url('~@/assets/common/graduate-logo.png') center no-repeat;
      background-size: contain;
    }
  }

  .body {
    margin-top: 30px;

    .result-wrap {
      .result-title {
        padding: 15px 20px;
        color: #005ea6;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }

      .result-content {
        .no-data {
          padding: 60px 20px;
          text-align: center;
          color: #909399;
          font-size: 14px;
        }

        .result-list {
          .result-card {
            margin-bottom: 15px;
            border-radius: 8px;
            background-color: #FFF;
            box-shadow: 0 0 6px rgba(0, 0, 0, .1);
            overflow: hidden;

            &:last-child {
              margin-bottom: 0;
            }

            .card-header {
              padding: 12px 20px;
              background-color: #005ea6;

              .card-title {
                color: #fff;
                font-size: 15px;
                font-weight: bold;
              }
            }

            .card-body {
              padding: 20px;
              display: flex;
              gap: 20px;

              .info-section {
                flex: 1;
              }

              .info-item {
                padding: 12px 0;
                border-bottom: 1px solid #EBEEF5;
                display: flex;
                align-items: flex-start;

                &:last-child {
                  border-bottom: none;
                }

                .label {
                  flex-shrink: 0;
                  width: 110px;
                  color: #005ea6;
                  font-size: 14px;
                  font-weight: bold;
                }

                .value {
                  flex: 1;
                  color: #303133;
                  font-size: 14px;
                  word-break: break-all;
                }
              }

              .photo-section {
                flex-shrink: 0;
                width: 150px;
                display: flex;
                align-items: flex-start;
                justify-content: center;

                .student-photo {
                  max-width: 100%;
                  max-height: 200px;
                  border-radius: 4px;
                  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                }
              }
            }
          }
        }
      }
    }

    .result-footer {
      margin-top: 30px;
      display: flex;
      justify-content: center;

      .el-button {
        width: 65%;
        max-width: 300px;
        height: 44px;
        font-size: 16px;
        background-color: #005ea6 !important;
        border-color: #005ea6 !important;
        border-radius: 22px !important;

        &:hover,
        &:focus {
          background-color: #006bb8 !important;
          border-color: #006bb8 !important;
        }
      }
    }
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .page-graduate-result {
    .body {
      .result-wrap {
        .result-content {
          .result-list {
            .result-card {
              .card-body {
                padding: 15px 10px;
                gap: 10px;

                .info-section {
                  flex: 1;
                  min-width: 0;

                  .info-item {
                    padding: 10px 0;

                    .label {
                      width: 80px;
                      font-size: 13px;
                    }

                    .value {
                      font-size: 13px;
                    }
                  }
                }

                .photo-section {
                  width: 90px;

                  .student-photo {
                    max-height: 120px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
